export function getFullName(obj) {
	const { FirstName, LastName, Name } = obj;

	return FirstName && LastName ? `${FirstName} ${LastName}` : Name || '';
}

export function getSecondLevelDomain(hostname: string): string {
	const parts = hostname.split('.');
	if (parts.length < 2) {
		return '';
	}
	return parts[parts.length - 2];
}
